import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: '首页'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartWarehouse'
            },
            {
              path: '/software/smartWarehouse',
              name: 'smartWarehouse',
              component: resolve => require(['@/view/Software_smartWarehouse'], resolve),
              meta: {
                title: '软件产品丨智能仓储系统'
              }
            },
            {
              path: '/software/crossBorderEcommerce',
              name: 'crossBorderEcommerce',
              component: resolve => require(['@/view/Software_crossBorderEcommerce'], resolve),
              meta: {
                title: '软件产品丨跨境电商平台'
              }
            },
            {
              path: '/software/officialWebsite',
              name: 'officialWebsite',
              component: resolve => require(['@/view/Software_officialWebsite'], resolve),
              meta: {
                title: '软件产品丨企业官方网站'
              }
            },
            {
              path: '/software/immigrationConsulting',
              name: 'immigrationConsulting',
              component: resolve => require(['@/view/Software_immigrationConsulting'], resolve),
              meta: {
                title: '软件产品丨移民咨询平台'
              }
            },
            {
              path: '/software/cryptoExchange',
              name: 'cryptoExchange',
              component: resolve => require(['@/view/Software_cryptoExchange'], resolve),
              meta: {
                title: '软件产品丨加密货币交易系统'
              }
            },
            {
              path: '/software/restaurantOrdering',
              name: 'restaurantOrdering',
              component: resolve => require(['@/view/Software_restaurantOrdering'], resolve),
              meta: {
                title: '软件产品丨餐馆下单小程序'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '相关服务'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js